var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "text-input" },
    [
      _c("FormLabel", {
        attrs: { for: _vm.name, required: _vm.required, value: _vm.label },
      }),
      _vm._v(" "),
      _c("FormInput", {
        attrs: {
          name: _vm.name,
          type: _vm.type,
          disabled: _vm.disabled,
          required: _vm.required,
          readonly: _vm.readonly,
          value: _vm.content,
        },
        on: {
          input: function ($event) {
            return _vm.$emit("input", $event)
          },
        },
      }),
      _vm._v(" "),
      _c("Transition", { attrs: { mode: "out-in", name: "view" } }, [
        _vm.error
          ? _c("span", {
              domProps: { textContent: _vm._s(_vm.errorMessageCompiled) },
            })
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./scripts/vue/Checkout/Components/Form/InputBlock.vue